import { SiteUtilities } from './utils';
let scheduledEventData = {};
let isTrial = 'no';
let accountUrl = '';
let customGrpId = '';

const init = (trialStatus, calendlyUrl, customGroupId) => {
  prefilUserInfo(calendlyUrl);
  isTrial = trialStatus;
  customGrpId = customGroupId;
  enableEventListener();
};

const isCalendlyEvent = (e) => {
  return e.data.event && e.data.event.indexOf('calendly') === 0;
};

const enableEventListener = () => {
  window.addEventListener(
    'message',
    function (e) {
      if (isCalendlyEvent(e)) {
        if (e.data.event === 'calendly.event_scheduled') {
          invokeCalendlyAPI(e.data);
        }
      }
    }
  );
};

const invokeCalendlyAPI = (e) => {
  const endPoints = parseEventAndInviteeUrl(e);
  getCalendlyData(endPoints.inviteeUrl, parseInviteeData, endPoints);
};

const convertTimeToIST = (time, eventData) => {
  try {
    const formatDateVar = (num) => {
      const d = (num).toString();
      return (d.length !== 2) ? `0${d}` : d;
    };
    const d = new Date(time).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    const date = d.split(',')[0].split('/');
    const day = formatDateVar(date[1]);
    const month = formatDateVar(date[0]);
    const year = date[2];
    return {
      date: `${year}-${month}-${day}`,
      time: d.split(',')[1]
    };
  } catch (e) {
    const error = {
      eventData,
      actualError: e
    };
    logFailures(error);
  }
};

const postDataToFdesk = (eventData) => {
  const localStartTime = convertTimeToIST(eventData.startTime, eventData);
  const localEndTime = convertTimeToIST(eventData.endTime, eventData);
  let desc = `Event Type: ${eventData.eventName}<br>Invitee: ${eventData.inviteeName}<br>Invitee Email: ${eventData.inviteeEmail}<br>` +
  `Event Start Time: ${localStartTime.date} ${localStartTime.time}<br>` +
  `Event End Time: ${localEndTime.date} ${localEndTime.time}<br>` +
  `Onboarding specialist : ${eventData.eventOwnerName}<br>Domain: ${eventData.domain || ''}<br>` +
  `${(accountUrl) ? 'Account Url: ' + accountUrl + '<br>' : ''}`;
  if (eventData.qAndAArray && eventData.qAndAArray.length) {
    for (const e of eventData.qAndAArray) {
      desc = `${desc}${e.question}:${e.answer}<br>`;
    }
  }
  const ticketCreateBody = {
    subject: eventData.eventName,
    description: JSON.stringify(desc),
    email: eventData.inviteeEmail,
    group_id: 50000000073,
    email_config_id: 50000000031,
    status: 2,
    custom_fields: {
      bu: eventData.product,
      cf_dap_source: eventData.source,
      cf_dap_start_date: localStartTime.date,
      reuest_type: 'Digital Adoption request',
      cf_engagement_status: 'In Progress',
      cf_zoom_links: eventData.meetingId
    }
  };
  if (isTrial && isTrial === 'yes') {
    ticketCreateBody.group_id = 50000000165;
    ticketCreateBody.custom_fields = {};
    ticketCreateBody.custom_fields.bu = eventData.product;
  }
  if (eventData.bannerType) {
    ticketCreateBody.custom_fields.cf_se = eventData.bannerType;
  }
  if (customGrpId) {
    ticketCreateBody.group_id = Number(customGrpId);
  }
  eventData.startTime = `${localStartTime.date} ${localStartTime.time}`;
  eventData.endTime = `${localEndTime.date} ${localEndTime.time}`;
  const fdeskPayload = {
    method: 'POST',
    data: JSON.stringify({
      id: 'fdesk',
      payload: ticketCreateBody,
      eventData
    }),
    url: 'https://alfred.freshworks.com/v1/google-spreadsheet-api-write'
  };
  $.ajax(fdeskPayload).done(function () {
  }).fail(function (e) {
    logFailures(e);
  });
};

const parseEventAndInviteeUrl = (data) => {
  try {
    return {
      eventUrl: data.payload.event.uri,
      inviteeUrl: data.payload.invitee.uri
    };
  } catch (e) {
    logFailures(e);
  }
};

const parseInviteeData = (response, endPoints) => {
  try {
    scheduledEventData = {};
    const invitee = response.resource;
    scheduledEventData.inviteeName = invitee.name || null;
    scheduledEventData.inviteeEmail = invitee.email || null;
    scheduledEventData.timezone = invitee.timezone || null;
    const trackingObj = invitee.tracking || null;
    const queAndAns = invitee.questions_and_answers || null;
    scheduledEventData.qAndAArray = (Array.isArray(queAndAns) && queAndAns.length) ? queAndAns : [];
    scheduledEventData.product = trackingObj.utm_source || null;
    scheduledEventData.source = SiteUtilities.getParameterByName('utm_source') || null;
    scheduledEventData.domain = SiteUtilities.getParameterByName('utm_domain') || null;
    scheduledEventData.bannerType = SiteUtilities.getParameterByName('utm_bannertype') || null;
    getCalendlyData(endPoints.eventUrl, parseEventData, endPoints);
  } catch (e) {
    logFailures(e);
  }
};

const parseEventOwnerDate = (response) => {
  try {
    const resource = response.resource;
    scheduledEventData.eventOwnerEmail = resource.email || null;
    scheduledEventData.eventOwnerName = resource.name || null;
    postDataToFdesk(scheduledEventData);
  } catch (e) {
    logFailures(e);
  }
};

const parseEventData = (response) => {
  try {
    const eventData = response.resource;
    if (!Array.isArray(eventData.event_memberships) || eventData.event_memberships.length === 0) {
      return;
    }
    scheduledEventData.startTime = eventData.start_time || null;
    scheduledEventData.endTime = eventData.end_time || null;
    scheduledEventData.eventName = eventData.name || null;
    const eventOwnerDataUrl = eventData.event_memberships[0]['user'];
    getMeetingID(eventData);
    if (eventOwnerDataUrl) {
      getCalendlyData(eventOwnerDataUrl, parseEventOwnerDate);
    }
  } catch (e) {
    logFailures(e);
  }
};

const getMeetingID = (response) => {
  const location = response.location || null;
  if (location && location.data && location.data.id) {
    scheduledEventData.meetingId = location.data.id;
  }
};

const getCalendlyData = (endPoint, callback, endPoints = '') => {
  $.ajax({
    method: 'POST',
    data: JSON.stringify({
      id: 'calendly',
      url: endPoint,
      pageurl: window.location.href
    }),
    dataType: 'json',
    contentType: 'application/json',
    url: 'https://alfred.freshworks.com/v1/google-spreadsheet-api-write'
  }).done(function (response) {
    callback(response, endPoints);
  }).fail(function (e) {
    logFailures(e);
  });
};

const logFailures = (data) => {
  $.ajax({
    method: 'POST',
    data: JSON.stringify({
      id: 'dynamo',
      payload: { error: {
        pageurl: window.location.href,
        data: data
      } }
    }),
    dataType: 'json',
    contentType: 'application/json',
    url: 'https://alfred.freshworks.com/v1/google-spreadsheet-api-write'
  }).done(function (response) {
  }).fail(function (e) {
    console.log(e);
  });
};

const initializeCalendly = (calendlyUrl, retriesLeft) => {
  if (window.Calendly) {
    try {
      const encodedUri = encodeURI(calendlyUrl);
      const $iframeTag = $('.calendly-inline-widget');
      const $iframe = $iframeTag ? $iframeTag.find('iframe') : null;
      if (!$iframe || !$iframe.length) {
        setTimeout(function () {
          initializeCalendly(calendlyUrl, retriesLeft - 1);
        }, 500);
      }
      $iframe.each((index, tag) => {
        $(tag).remove();
      });
      Calendly.initInlineWidget({
        url: encodedUri,
        parentElement: $iframeTag
      });
    } catch (e) {
      console.log('Calendly Obj not available ', e);
    }
  } else if (retriesLeft > 0) {
    setTimeout(function () {
      initializeCalendly(calendlyUrl, retriesLeft - 1);
    }, 500);
  }
};

const prefilUserInfo = (calendlyUrl) => {
  let canUpdateSrc = false;
  if (calendlyUrl) {
    accountUrl = SiteUtilities.getParameterByName('a1') || '';
    if (SiteUtilities.getParameterByName('calendlyuser') && SiteUtilities.getParameterByName('calendlydomain')) {
      const email = `${SiteUtilities.getParameterByName('calendlyuser')}@${SiteUtilities.getParameterByName('calendlydomain')}`;
      calendlyUrl = `${calendlyUrl}${calendlyUrl.includes('?') ? '&' : '/?'}email=${email}`;
      canUpdateSrc = true;
    }
    const keys = ['name', 'a1'];
    for (const d of keys) {
      if (SiteUtilities.getParameterByName(d)) {
        calendlyUrl = `${calendlyUrl}${calendlyUrl.includes('?') ? '&' : '/?'}${d}=${SiteUtilities.getParameterByName(d)}`;
        canUpdateSrc = true;
      }
    }
    if (canUpdateSrc) {
      setTimeout(function () {
        initializeCalendly(calendlyUrl, 10);
      }, 500);
    }
  }
};

export default { init };
